import { Link } from "react-router-dom";
import { Phone, Printer, MapPin, Mail, ArrowUpRight } from "lucide-react";
import { COMPANY } from "../../lib/site-data";
import { LOGO_URL } from "../../lib/brand";
import { FOOTER } from "../../constants/testIds";

export const Footer = () => {
  return (
    <footer
      data-testid={FOOTER.root}
      className="bg-[color:var(--brand-navy)] text-white"
    >
      <div className="container-tg py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="mb-6">
              <img
                src={LOGO_URL}
                alt="Tecnografic logo"
                className="h-16 w-auto object-contain"
              />
            </div>
            <p className="text-white/70 leading-relaxed max-w-sm mb-8">
              {COMPANY.shortAbout}
            </p>
            <div className="inline-flex items-center gap-2 px-3 py-2 bg-[color:var(--brand-yellow)] text-[color:var(--brand-navy)] text-xs font-bold uppercase tracking-widest">
              Est. 1998 — Fort Lauderdale, FL
            </div>
          </div>

          <div className="md:col-span-3" data-testid={FOOTER.contactBlock}>
            <h4 className="overline text-[color:var(--brand-yellow)] mb-6">Contact</h4>
            <ul className="space-y-4 text-sm text-white/85">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-[color:var(--brand-yellow)]" />
                <span>
                  {COMPANY.address.street}
                  <br />
                  {COMPANY.address.city}
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-[color:var(--brand-yellow)]" />
                <a href={`tel:${COMPANY.phone}`} className="hover:text-[color:var(--brand-yellow)]">
                  {COMPANY.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Printer className="w-4 h-4 text-[color:var(--brand-yellow)]" />
                <span>Fax: {COMPANY.fax}</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-[color:var(--brand-yellow)]" />
                <a href={`mailto:${COMPANY.email}`} className="hover:text-[color:var(--brand-yellow)]">
                  {COMPANY.email}
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="overline text-[color:var(--brand-yellow)] mb-6">Explore</h4>
            <ul className="space-y-3 text-sm">
              {[
                ["Home", "/"],
                ["Services", "/services"],
                ["Portfolio", "/portfolio"],
                ["About", "/about"],
                ["Contact", "/contact"],
              ].map(([label, to]) => (
                <li key={to}>
                  <Link to={to} className="text-white/80 hover:text-[color:var(--brand-yellow)] transition-colors">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="overline text-[color:var(--brand-yellow)] mb-6">More</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="https://hydrofablab.com"
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-1 text-white/80 hover:text-[color:var(--brand-yellow)]"
                >
                  HydroFabLab <ArrowUpRight className="w-3 h-3" />
                </a>
              </li>
              <li>
                <Link to="/contact" className="text-white/80 hover:text-[color:var(--brand-yellow)]">
                  Request a Quote
                </Link>
              </li>
              <li>
                <Link to="/accessibility" className="text-white/80 hover:text-[color:var(--brand-yellow)]">
                  Accessibility
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-white/50">
          <span>© {new Date().getFullYear()} Tecnografic. All rights reserved.</span>
          <span className="uppercase tracking-widest">
            Website Designed By{" "}
            <a
              href="https://bp.agency"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-brand-partners-link"
              className="font-extrabold text-white hover:text-[color:var(--brand-yellow)] underline-offset-2 hover:underline"
            >
              Brand Partners
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
